import React, { Suspense, useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import genStyles from "../../generale.module.css";
import { apiCollectionState, boolModifState, collectionsCurState, idLayerEditState, localDataState, markerFormEditState, toastState, typeCollectionState, userDataState } from "../../../atoms/CollectionState";
import { DropdownSelect } from "../../dropdownSelect";
import DrawService from "../../../service/DrawService";
import FileForm from "./fileForm";
import ShowService from "../../../service/showService";
import TooltipForm from "../../tooltipForm";
import FullScreenModal from "../../modalForm/fullScreenModal";
const EditorForm = React.lazy(() => import("../../editorForm"));

export default function MarkerTextForm({setEntiteslist, openEntityList, deleteEntityList, objectCur, returnToEntityList, collectionName}) {
    const [form, setForm] = useRecoilState(markerFormEditState);
    const layerEdit = useRecoilValue(idLayerEditState);
    const collectioncur = useRecoilValue(collectionsCurState);
    const typeCollection = useRecoilValue(typeCollectionState);  
    const LocalData = useRecoilValue(localDataState); 
    const api_collection = useRecoilValue(apiCollectionState);
    const user_data = useRecoilValue(userDataState);  
    const [nomCreateur, setNomCreateur] = useState('');    
    const [nomModif, setNomModif] = useState('');    
    const [dateModif, setDateModif] = useState('');    
    const setBoolModif = useSetRecoilState(boolModifState);     
    const setToast = useSetRecoilState(toastState); 
    const [showEditor, setShowEditor] = useState(false);
    const [overlayTop, setOverlayTop] = useState(0);
    const headerRef = useRef(null);
    
    useEffect(() => {
        if(headerRef.current){
            setOverlayTop(headerRef.current.getBoundingClientRect().bottom);
        }
    
        if(!LocalData){
            setNomCreateur(objectCur?.sogefi_nom_creation ?? 'Utilisateur inconnu');
            setNomModif(objectCur?.sogefi_nom_modification ?? 'Utilisateur inconnu');
            if (objectCur?.sogefi_date_modification) {
                setDateModif(objectCur.sogefi_date_modification);
            } 
        }
    }, []);

    const updateField = (key, value) => {
        setBoolModif(true);
        let colorText = form.textColor;
        let sizeText = form.textSize+'px';
        setForm((prev) => {
            const updatedForm = { ...prev, [key]: value };
            const updatedLayer = DrawService.updatePropertieLayer(updatedForm, layerEdit,'textMarker');            
            if (updatedLayer) {       
                if(key === 'textColor') colorText = value;
                if(key === 'textSize') sizeText = value+'px';
                const updatedGeoJSON = updatedLayer.toGeoJSON();                
                const updatedGeom = JSON.stringify(updatedGeoJSON.geometry);
                updatedGeoJSON.properties = updatedLayer.data;
                updatedGeoJSON.properties.css = {'color':colorText,'font-size':sizeText};

                setEntiteslist((prevList) => {
                    const updatedList = prevList.map((entity) => {
                        if (entity.id === updatedLayer.data.id) {
                            const updatedEntity = { 
                                ...entity, 
                                geojson: updatedGeoJSON,
                                geom : updatedGeom,
                                titre:updatedLayer.data.titre,
                                observation:updatedLayer.data.observation,
                                css:{'color':colorText,'font-size':sizeText},
                            };
                            return updatedEntity;
                        }
                        return entity;
                    });
                    return updatedList;
                });
            }
            return updatedForm;
        });
    };

    // Fonction pour vérifier si une date correspond à aujourd'hui
    const isToday = (dateStr) => {
        if (!dateStr) return false;
        const date = new Date(dateStr.replace(" ", "T"));
        const today = new Date();
        return date.getDate() === today.getDate() &&
               date.getMonth() === today.getMonth() &&
               date.getFullYear() === today.getFullYear();
    };

    // Fonction pour formater une date avec "aujourd'hui" si nécessaire
    const formatDateWithToday = (dateStr) => {
        if (!dateStr) return "";
        if (isToday(dateStr)) {
            // Extraire l'heure de la date
            const date = new Date(dateStr.replace(" ", "T"));
            const heures = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            return `aujourd'hui à ${heures}h${minutes}`;
        }
        return ShowService.formatDate(dateStr);
    };

    const getEntityInfo = () => {
        if (!objectCur.sogefi_date) return "";
        const dateCreation = formatDateWithToday(objectCur.sogefi_date);
        const isCreationToday = isToday(objectCur.sogefi_date);
        const prefixCreation = isCreationToday ? "" : "le ";
        let infoText = `Créé par ${nomCreateur} ${prefixCreation}${dateCreation}`;
        if (nomModif && dateModif) {
            const dateModifFormatted = formatDateWithToday(dateModif);
            const isModifToday = isToday(dateModif);
            const prefixModif = isModifToday ? "" : "le ";
            infoText += `\n\nDernière modification par ${nomModif} ${prefixModif}${dateModifFormatted}`;
        }
        return infoText;
    };

    const presetColors = [
        { name: "#36c980", iconClass: "#36c980" },
        { name: "#a0d44f", iconClass: "#a0d44f" },
        { name: "#c9b957", iconClass: "#c9b957" },
        { name: "#face47", iconClass: "#face47" },
        { name: "#7945ca", iconClass: "#7945ca" },
        { name: "#a15bd5", iconClass: "#a15bd5" },
        { name: "#6499f4", iconClass: "#6499f4" },
        { name: "#76cbf9", iconClass: "#76cbf9" },
        { name: "#b63453", iconClass: "#b63453" },
        { name: "#db465e", iconClass: "#db465e" },
        { name: "#f61e87", iconClass: "#f61e87" },
        { name: "#f75cbf", iconClass: "#f75cbf" },
        { name: "#f7683c", iconClass: "#f7683c" },
        { name: "#f7af54", iconClass: "#f7af54" },
        { name: "#7d5247", iconClass: "#7d5247" },
        { name: "#818181", iconClass: "#818181" },
        { name: "#252525", iconClass: "#252525" },
        { name: "#FFFFFF", iconClass: "#FFFFFF" },
    ];
    
    const copiecoord = () => {
        if (form.latitude != null && form.longitude != null) {
          // On force les valeurs à nombre et on formate avec un point comme séparateur
          const lat = parseFloat(form.latitude).toString();
          const lng = parseFloat(form.longitude).toString();
      
          // Concaténation avec une virgule
          const coordText = `${lat},${lng}`;
      
          const textarea = document.createElement("textarea");
          textarea.value = coordText;
          document.body.appendChild(textarea);
          textarea.select();
          try {
            const successful = document.execCommand("copy");
            if (successful) {
                setToast({ message: "Coordonnées copiées dans le presse-papier" , type: 'success' }); 
            } else {
              throw new Error("Échec de la copie");
            }
          } catch (err) {
            console.error("Erreur copie coordonnée :", err);
            setToast({ message: "Impossible de copier" , type: 'error' });
          } finally {
            document.body.removeChild(textarea);
          }
        }
    };

    const setZoomEntity = () => {
        const geojson = objectCur?.geojson;
        ShowService.addEntitesToMap(geojson,'zoom');
    };

    return (
        <> 
        {/* Barre d'outils style Google */}
            <div className={genStyles.buttonheaderfrm} ref={headerRef}>
            {(typeCollection == 'collection' || collectioncur.edit) && (
            <>
                <TooltipForm content="Supprimer l'entité">
                    <button
                        className="btn-floating red lighten-1"
                        onClick={deleteEntityList}
                    >
                        <i className="fa-solid fa-trash"></i>
                    </button>
                </TooltipForm>
                <TooltipForm content="Enregistrer les modifications">
                    <button
                        className="btn-floating green lighten-1"
                        onClick={openEntityList}
                    >
                        <i className="fa-solid fa-floppy-disk"></i>
                    </button>
                </TooltipForm>
                <TooltipForm content={`Zoomer sur l'entité`}>
                    <button
                        className="btn-floating yellow darken-3"
                        onClick={setZoomEntity}
                    >
                        <i className="fa-solid fa-magnifying-glass-plus"></i>
                    </button>
                </TooltipForm>
                <TooltipForm content={getEntityInfo()}>
                    <button
                        className="btn-floating blue lighten-1"
                    >
                        <i className="fa-solid fa-info"></i>
                    </button>
                </TooltipForm>
            </>
            )}
            </div>
        
        <div className={`${genStyles.editFormContainer} scroller`}>
            <div className={genStyles.editFormSection}>
                {/* --- Info générale --- */}
                <div className={genStyles.titleedsection}>
                    <i className={`fa-solid fa-square-info ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                    <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                    Information générale
                    </span>
                </div>
                <div className={`mb10`}>
                    <span className={`${genStyles.fontSize15} black-text`}>
                    Texte à afficher
                    </span>
                    <input 
                    className={genStyles.inputtCol}
                    type="text"
                    placeholder="Donner un nom à votre entité"
                    value={form.nomEntite}
                    maxLength={50}
                    onChange={(e) => updateField("nomEntite", e.target.value)}
                    />
                </div>
                <div className={`mb0`}>
                    <span className={`${genStyles.fontSize15} black-text`}>
                    Observation <i className={`fa-solid fa-pencil ${genStyles.fontSize16} ${genStyles.icomarginObserv}`} onClick={() => setShowEditor(true)}></i>
                    </span>
                    <div
                        className={`${genStyles.observationPreview}`}
                        dangerouslySetInnerHTML={{ __html: form.observation}}
                    />
                </div>
            </div>

            {/* --- Paramètres géographiques --- */}
            <div className={genStyles.editFormSection}>
                <div className={genStyles.titleedsection}
                 style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <div>
                        <i className={`fa-solid fa-location-dot ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                        <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                        Paramètres géographiques
                        </span>
                    </div>
                    <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>
                        <a onClick={copiecoord}>
                            <TooltipForm content={`Copier les coordonnées`}>
                                <i className="fa-sharp fa-solid fa-copy black-text text-darken-3" aria-hidden="true"></i>
                            </TooltipForm>
                            </a>
                    </span>
                </div>
                <div className="row mb0">
                    <div className="col s6">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Latitude</span>
                        <input 
                            className={genStyles.inputtCol}
                            type="number"
                            step="0.0001"
                            value={form.latitude ?? ""}
                            onChange={(e) => updateField("latitude", parseFloat(e.target.value) || 0)}
                        />
                    </div>

                    <div className="col s6">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Longitude</span>
                        <input 
                            className={genStyles.inputtCol}
                            type="number"
                            step="0.0001"
                            value={form.longitude ?? ""}
                            onChange={(e) => updateField("longitude", parseFloat(e.target.value) || 0)}
                        />
                    </div>
                </div>
            </div>

            {/* --- Style --- */}
            <div className={genStyles.editFormSection}>
                <div className={genStyles.titleedsection}>
                    <i className={`fa-solid fa-palette ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                    <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                    Styles
                    </span>
                </div>
                <div className="row mb0">
                    <div className="col s6">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Couleur du texte</span>
                        <div className={genStyles.pickctn}>
                            <DropdownSelect
                                options={presetColors}
                                selected={form.textColor}
                                onChange={(color) => updateField("textColor", color)}
                                type="color"
                                showCustomColor={true}
                            />                               
                            <input 
                                className={genStyles.inputtCol}
                                type="text"
                                value={form.textColor}
                                onChange={(e) => updateField("textColor", e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col s6">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Taille du texte</span>
                        <div className={genStyles.pickctn}>  
                            <input 
                                className={genStyles.inputtCol}
                                type="number"
                                value={Number(form.textSize) || 12}
                                onChange={(e) => updateField("textSize", e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {!LocalData && (
                <FileForm objectCur={objectCur}  setEntites={setEntiteslist} />
            )}

        </div>


        {/* Div overlay pour bloquer et griser */}
        {typeCollection === "shared" && (!collectioncur?.edit) && (
            <div className={genStyles.ctnDisabled}  style={{ top: overlayTop }} />
        )}

        {showEditor && (
            <FullScreenModal>
                <Suspense fallback={<div>Chargement de l’éditeur...</div>}>
                    <EditorForm value={form.observation}  onChange={(html) => updateField("observation", html)} onClose={() => setShowEditor(false)} />
                </Suspense>
            </FullScreenModal>        
        )}
        </>
    );
}
